import state from './state';

let initialState = state;

export default (state = initialState, action) => {
  
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar/reducers.js